import {
  GET_FORM_BY_ID_REQUEST,
  GET_FORM_BY_ID_SUCCESS,
  GET_FORM_BY_ID_FAILURE,
  VALIDATE_FORM_REQUEST,
  VALIDATE_FORM_FAILURE,
  VALIDATE_FORM_SUCCESS,
  ADD_FORM_REQUEST,
  ADD_FORM_SUCCESS,
  ADD_FORM_FAILURE,
  TOGGLE_INSTRUCTION,
  SUPPORTING_DOC_ADDED,
  SUPPORTING_DOC_DELETE_SUCCESS,
  OPEN_FORM_CHOICE_MODAL,
  CLOSE_FORM_CHOICE_MODAL,
  OPEN_FORM_CONFIRMATION,
  CLOSE_FORM_CONFIRMATION,
  FORM_CERTIFY_REQUEST,
  FORM_CERTIFY_SUCCESS,
  FORM_CERTIFY_FAILURE,
  FORM_REVERT_REQUEST,
  FORM_REVERT_SUCCESS,
  FORM_CERTIFY_RESET,
  FORM_REVERT_FAILURE,
  FORM_CONFIRM_REQUEST,
  FORM_CONFIRM_COMPLETE,
  FORM_SUBMIT_REQUEST,
  FORM_SUBMIT_COMPLETE,
  GET_FORM_PDF_REQUEST,
  GET_FORM_PDF_SUCCESS,
  GET_FORM_PDF_FAILURE,
  GET_FORM_PDF_CLEAR,
  OPEN_FORM_SIGNING,
  CLOSE_FORM_SIGNING,
  FORM_SIGNING_REQUEST,
  FORM_SIGNING_SUCCESS,
  FORM_SIGNING_FAILURE,
  SET_SUBMISSION_STAGE,
  SET_SELECTED_ACCOUNT,
  ADD_FORM_GROUP_REQUEST,
  ADD_FORM_GROUP_SUCCESS,
  ADD_FORM_GROUP_FAILURE,
  GET_FORM_GROUP_SUPPORTING_DOCS_REQUEST,
  GET_FORM_GROUP_SUPPORTING_DOCS_SUCCESS,
  GET_FORM_GROUP_SUPPORTING_DOCS_FAILURE,
  TIN_MATCH_RESET,
  GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_SUCCESS,
  GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_FAILURE,
  GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_REQUEST
} from 'actions';

import { submissionStages } from 'common/forms/submissionStages';

// eslint-disable-next-line default-param-last
function form(state = {
  isAddingForm: null,
  isGettingForm: false,
  formData: {
    SignDate: null
  },
  isValidatingForm: false,
  validationResult: null,
  supportingDocs: null,
  formReviewState: null,
  workflowState: null,
  formError: null,
  supportingDocError: null,
  instructionToggled: null,
  isFormConfirmationShown: false,
  isSubmittingForm: false,
  isConfirmingForm: false,
  isCertifyingForm: false,
  isSigningForm: false,
  submissionStage: submissionStages.Validating,
  pdfData: null,
  isFetchingPdfForm: false,
  downloadRequestFormType: null,
  isGettingFormGroupSupportingDocs: false,
  isFormChoiceShown: false,
  linkedCollectableSupportingDocId: null,
  isGettingLinkedCollectableSupportingDocId: false
}, action) {
  switch (action.type) {
    case SET_SELECTED_ACCOUNT:
      return {
        ...state,
        selectedAccountId: action.accountId
      };
    case OPEN_FORM_CHOICE_MODAL:
      return {
        ...state,
        formType: action.formType,
        isFormChoiceShown: action.isFormChoiceShown
      };
    case CLOSE_FORM_CHOICE_MODAL:
      return {
        ...state,
        isFormChoiceShown: action.isFormChoiceShown
      };
    case GET_FORM_BY_ID_REQUEST:
      return {
        ...state,
        isGettingForm: true,
        formData: null,
        isValidatingForm: false,
        validationResult: null,
        supportingDocs: null,
        formReviewState: null,
        workflowState: null,
        formError: null,
        supportingDocError: null,
        accCollectableSupportingDocs: null
      };
    case GET_FORM_BY_ID_SUCCESS:
      return {
        ...state,
        isGettingForm: false,
        formData: action.formData,
        validationResult: action.validationResult,
        supportingDocs: action.supportingDocs,
        formReviewState: action.formReviewState,
        workflowState: action.workflowState,
        formError: null,
        supportingDocError: null,
        submissionStage: submissionStages.Validating,
        accCollectableSupportingDocs: action.accCollectableSupportingDocs
      };
    case GET_FORM_BY_ID_FAILURE:
      return {
        ...state,
        isGettingForm: false,
        formData: null,
        validationResult: null,
        supportingDocs: null,
        formReviewState: null,
        workflowState: null,
        formError: action.formError,
        supportingDocError: null,
        submissionStage: submissionStages.Validating,
        accCollectableSupportingDocs: null
      };
    case VALIDATE_FORM_REQUEST:
      return {
        ...state,
        isValidatingForm: true
      };
    case VALIDATE_FORM_SUCCESS:
      return {
        ...state,
        isValidatingForm: false,
        validationResult: action.validationResponse.success ? action.validationResponse.data : null
      };
    case VALIDATE_FORM_FAILURE:
      return {
        ...state,
        isValidatingForm: false
      };
    case ADD_FORM_REQUEST:
      return {
        ...state,
        isAddingForm: action.isAddingForm
      };
    case ADD_FORM_SUCCESS:
      return {
        ...state,
        isAddingForm: null
      };
    case ADD_FORM_FAILURE:
      return {
        ...state,
        isAddingForm: null
      };
    case ADD_FORM_GROUP_REQUEST:
      return {
        ...state,
        isAddingFormGroup: action.isAddingFormGroup,
        accCollectableSupportingDocs: null
      };
    case ADD_FORM_GROUP_SUCCESS:
      return {
        ...state,
        isAddingFormGroup: null,
        accCollectableSupportingDocs: action.accCollectableSupportingDocs
      };
    case ADD_FORM_GROUP_FAILURE:
      return {
        ...state,
        isAddingFormGroup: null,
        accCollectableSupportingDocs: null
      };
    case TOGGLE_INSTRUCTION:
      return {
        ...state,
        instructionToggled: action.instructionToggled
      };
    case SUPPORTING_DOC_ADDED:
      return {
        ...state,
        supportingDocs: action.newSupportingDoc ? state.supportingDocs.concat(action.newSupportingDoc) : state.supportingDocs
      };
    case SUPPORTING_DOC_DELETE_SUCCESS:
      return {
        ...state,
        supportingDocs: state.supportingDocs ? state.supportingDocs.filter(doc => doc.id !== action.isDeletingSupportingDocId) : state.supportingDocs
      };
    case OPEN_FORM_CONFIRMATION:
      return {
        ...state,
        isFormConfirmationShown: action.isFormConfirmationShown
      };
    case CLOSE_FORM_CONFIRMATION:
      return {
        ...state,
        isFormConfirmationShown: action.isFormConfirmationShown
      };
    case FORM_CERTIFY_REQUEST:
      return {
        ...state,
        isCertifyingForm: true
      };
    case FORM_CERTIFY_SUCCESS:
      return {
        ...state,
        workflowState: action.workflowState,
        isCertifyingForm: false
      };
    case FORM_CERTIFY_FAILURE:
      return {
        ...state,
        isCertifyingForm: false
      };
    case FORM_CERTIFY_RESET:
      return {
        ...state,
        isCertifyingForm: false,
        workflowState: null
      };
    case FORM_REVERT_REQUEST:
      return {
        ...state
      };
    case FORM_REVERT_SUCCESS:
      return {
        ...state,
        workflowState: action.workflowState
      };
    case FORM_REVERT_FAILURE:
      return {
        ...state
      };
    case FORM_CONFIRM_REQUEST:
      return {
        ...state,
        isConfirmingForm: true
      };
    case FORM_CONFIRM_COMPLETE:
      return {
        ...state,
        isConfirmingForm: false
      };
    case FORM_SUBMIT_REQUEST:
      return {
        ...state,
        isSubmittingForm: true
      };
    case FORM_SUBMIT_COMPLETE:
      return {
        ...state,
        isSubmittingForm: false
      };
    case GET_FORM_PDF_REQUEST:
      return {
        ...state,
        isFetchingPdfForm: action.isFetchingPdfForm,
        pdfData: null,
        downloadRequestFormType: action.downloadRequestFormType
      };
    case GET_FORM_PDF_SUCCESS:
      return {
        ...state,
        isFetchingPdfForm: action.isFetchingPdfForm,
        pdfData: action.pdfData,
        downloadRequestFormType: action.downloadRequestFormType
      };
    case GET_FORM_PDF_FAILURE:
      return {
        ...state,
        isFetchingPdfForm: action.isFetchingPdfForm,
        pdfData: null,
        downloadRequestFormType: action.downloadRequestFormType
      };
    case GET_FORM_PDF_CLEAR:
      if (state.pdfData) {
        URL.revokeObjectURL(state.pdfData);
      }
      return {
        ...state,
        pdfData: null,
      };
    case OPEN_FORM_SIGNING:
      return {
        ...state,
        isNameInvalid: false,
        isSigningForm: false
      };
    case CLOSE_FORM_SIGNING:
      return {
        ...state,
        isNameInvalid: false,
        isSigningForm: false
      };
    case FORM_SIGNING_REQUEST:
      return {
        ...state,
        isNameInvalid: false,
        isSigningForm: true
      };
    case FORM_SIGNING_FAILURE:
      return {
        ...state,
        isNameInvalid: true,
        isSigningForm: false
      };
    case FORM_SIGNING_SUCCESS:
      return {
        ...state,
        workflowState: null,
        isSigningForm: false,
        isNameInvalid: false,
        submissionStage: action.submissionStage,
        lastSubmittedForm: action.id,
        linkedCollectableSupportingDocId: action.linkedCollectableSupportingDocId
      };
    case GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_SUCCESS:
      return {
        linkedCollectableSupportingDocId: action.id,
        isGettingLinkedCollectableSupportingDocId: false
      };
    case GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_REQUEST:
      return {
        linkedCollectableSupportingDocId: null,
        isGettingLinkedCollectableSupportingDocId: true
      };
    case GET_LINKED_COLLECTABLE_SUPPORTING_DOC_ID_FAILURE:
      return {
        linkedCollectableSupportingDocId: null,
        isGettingLinkedCollectableSupportingDocId: false
      };
    case SET_SUBMISSION_STAGE:
      return {
        ...state,
        submissionStage: action.submissionStage
      };
    case GET_FORM_GROUP_SUPPORTING_DOCS_REQUEST:
      return {
        ...state,
        isGettingFormGroupSupportingDocs: true,
        supportingDocs: null,
      };
    case GET_FORM_GROUP_SUPPORTING_DOCS_SUCCESS:
      return {
        ...state,
        isGettingFormGroupSupportingDocs: false,
        supportingDocs: action.supportingDocs,
      };
    case GET_FORM_GROUP_SUPPORTING_DOCS_FAILURE:
      return {
        ...state,
        isGettingFormGroupSupportingDocs: false,
        supportingDocs: null,
        formError: action.formError,
      };
    case TIN_MATCH_RESET:
      if (!state.validationResult) {
        return state;
      }
      return {
        ...state,
        validationResult: {
          ...state.validationResult,
          tinMatched: null
        }
      };
    default:
      return state;
  }
}

export default form;
